// Component for SideBar
import React from 'react';
import { theme } from '../../theme/theme';
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudDetailsSideBarContent from './CloudDetailsSideBarContent';

// export interface CloudDetailsSidebarProps {
//   cloudSystemSerial: string
// }

const CloudDetailsSidebar = (props) => {
  // State
  const [cloudSystem, setCloudSystem] = React.useState(null);

  const handleClose = () => {
    props.onClose();
  };
  
  const onNeedsGet = () => {
    // Tell parent to Get summaries
    if (props.onNeedsGet) { 
      props.onNeedsGet()
    }
  };

  React.useEffect(() => {
    if (props.cloudSystemSerial !== null && props.cloudSystemSerial !== undefined) {
      setCloudSystem(props.cloudSystemSerial);
    }
  }, [props.cloudSystemSerial]);

  // Inputs
  const open = props.cloudSystemSerial !== null;

  // View
  return (

    <Drawer
      anchor={'right'}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{ width: 500, overflowX: 'hidden', backgroundColor: theme.palette.primary.main, display: 'flex', flexDirection: 'column', flex: 1 }}
        role="presentation"
      >

        <Stack direction={"row"} sx={{backgroundColor: theme.palette.secondary.main}}>
          <Typography
            fontSize={14}
            fontWeight={400}
            color={theme.palette.secondary.contrastText}
            sx={{my: 1, ml: 2}}
          >
            {cloudSystem}
          </Typography>
          <IconButton
            onClick={handleClose}
            sx={{marginLeft: 'auto'}}
          >
            <CloseIcon htmlColor={theme.palette.secondary.contrastText} />
          </IconButton>
        </Stack>

        {/* Only renders the Content if we have a CloudSystemSerial */}
        {cloudSystem && (<CloudDetailsSideBarContent cloudSystemSerial={cloudSystem} onNeedsGet={onNeedsGet} onClose={handleClose} />)}
      </Box>
    </Drawer>
  );
};

export default CloudDetailsSidebar;
